import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT, withQuery } from '../utilities/FetchHelper';

class RateplansService {

    getBoxInventory(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_BOX_INVENTORY
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    getBaseRatePlans(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_BASE_RATE_PLANS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    getRateplans(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_RATE_PLANS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    getStandardRateplans(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_RATE_PLANS_STANDARD
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    getBlackouts(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_RATEPLAN_BLACKOUTS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    putBlackouts(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_RATEPLAN_BLACKOUTS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    putRateplans(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_RATE_PLANS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }
        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    putBaseRateplans(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_BASE_RATE_PLANS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }
        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new RateplansService()